import LoginEmail from '@root/login/src/components/login-email';
import PropTypes from '@root/vendor/prop-types';
import useAnalytics from '@root/core/src/hooks/use-analytics';

export default function LoginWithEmail({
  module, logout, domain, basePath,
}) {
  return (
    <LoginEmail
      analytics={useAnalytics([module, 'LOGIN_LINK'])}
      basePath={basePath}
      domain={domain}
      logout={logout}
    />
  );
}

LoginWithEmail.propTypes = {
  basePath: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  logout: PropTypes.func,
  module: PropTypes.string.isRequired,
};
